import { ChangePasswordImpl } from "../data/ChangePasswordImpl";
import { IChangePasswordRepository } from "../domain/repositories/IChangePasswordRepository";
import { ChangePasswordUseCase } from "../domain/useCases/ChangePasswordUseCase";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class ChangePasswordInjection extends InjectionModule {
  private static readonly changePasswordRepositoryToken = Symbol(
    "IChangePasswordRepository",
  );
  private static readonly changePasswordUseCaseToken = Symbol(
    "ChangePasswordUseCase",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.changePasswordRepositoryToken,
      useClass: ChangePasswordImpl,
    },
    {
      scope: "otherRepo",
      token: this.changePasswordUseCaseToken,
      useClass: ChangePasswordUseCase,
    },
  ];

  static getRepo(): IChangePasswordRepository {
    return this.resolve(this.changePasswordRepositoryToken);
  }

  static getUseCase(): ChangePasswordUseCase {
    return this.resolve(this.changePasswordUseCaseToken);
  }
}
